module.exports = __webpack_public_path__ + "media/images/girl-pr-55d69a3f2aa7cb48440853dbb5dec156.jpg";